import { Text } from 'preact-i18n';
import titleize from '../../utils/titleize';
import { selectIcon } from '../../templates/place';
import { getAllTerminalsLabel } from './displayTypes';

/**
 * A city all-terminals match that cannot be chosen because the opposite field already uses
 * one. It never reads the selection callbacks, so it cannot change the field. Preventing the
 * mousedown default keeps focus in the input: the dropdown does not blur closed, and on touch
 * the caret and keyboard stay.
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.place - The city all-terminals place, as returned by the places API.
 * @param {string} props.field - The field being edited, `origin` or `destination`.
 * @returns {JSX.Element} UnavailableElement component JSX element.
 */
const UnavailableElement = ({ place, field }) => (
  <li
    className="es-visible no-selectable unavailable-option"
    aria-disabled="true"
    onMouseDown={event => event.preventDefault()}
  >
    <div
      className="autocomplete-icon"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: selectIcon('building', false),
      }}
    />
    <div className="place-info-column">
      <div className="place-info">
        <b>{titleize(place.city_name || place.cityName)}</b> {`"${getAllTerminalsLabel()}"`}
      </div>
      <span className="unavailable-reason">
        <Text id={`notification.all_terminals_unavailable_${field}`} />
      </span>
    </div>
  </li>
);

export default UnavailableElement;
